"use strict";module.exports=Math.pow;